import PageHeader from '../../layout/PageHeader';
import { MainContainer } from '../../components/Contents/Contents.element';
import { usePlayerSearch } from '../../contexts/SearchPlayersContext';
import PlayerFilterResultsPage from '../../components/PlayerLanding/PlayerSearch/PlayerFilterResultsPage';
import './playersearch.css';
import { useCallback, useEffect } from 'react';
import { useNotification } from '../../contexts/NotificationContext';
import { useNavigate } from 'react-router-dom';
import { useSidebar } from '../../contexts/SidebarContext';
import './styles.css';

const PlayerSearchComponent = () => {
    const { playerSearchResultsVisible, setPlayerSearchResultsVisible, handleSelectedPlayer,
        handleSelectedAttributes, setAllProfiles, handleSelectedProfiles, handleSelectedPlayerZones,
        setTransferValue, transferValue, setTrueValue, trueValue, contractUntilValue, setContractUntilValue, setAgeRange, ageRange,
        setMinAppearances, setStartsOnly, setFoot, setRegionValues, setCompetitionValues, handleSelectedTags,
        setIsPlayerFilterChange, setIsAltered, setSimilarPlayerResultsList, handleSelectedPlayerAttributes,
        setPlayerInitialAttributes, setIsExactMatchesOnly, similarPlayerResultsList, originPage, reset,
        setWagesValue,
    } = usePlayerSearch();
    const navigate = useNavigate();
    const { hideNotification, setNotificationContent, setDisplayNotification } = useNotification();
    const { isBlurred } = useSidebar();

    const handleClearPlayerList = useCallback(() => {
        setPlayerSearchResultsVisible(false);
        handleSelectedPlayer([]);
        setAllProfiles([]);
        handleSelectedPlayerZones([]);
        handleSelectedProfiles([]);
        handleSelectedAttributes([]);
        handleSelectedPlayerAttributes([]);
        setTransferValue({ min: 0, max: 250000000 });
        setTrueValue({ min: 0, max: 250000000 });
        setWagesValue({ min: 0, max: 180000000 });
        setContractUntilValue({ min: 0, max: 120 });
        setAgeRange({ min: 16, max: 50 });
        setMinAppearances(0);
        setStartsOnly(false);
        setFoot([]);
        setRegionValues([]);
        setCompetitionValues([]);
        handleSelectedTags([]);
        setIsPlayerFilterChange(false);
        setIsAltered(false);
        setSimilarPlayerResultsList(undefined);
        setPlayerInitialAttributes([]);
        setIsExactMatchesOnly(false);
        hideNotification();
        setNotificationContent(null);
        setDisplayNotification(false);
    }, [
        setPlayerSearchResultsVisible,
        handleSelectedPlayer,
        setAllProfiles,
        handleSelectedPlayerZones,
        handleSelectedProfiles,
        handleSelectedAttributes,
        setTransferValue,
        transferValue,
        setTrueValue,
        trueValue,
        setContractUntilValue,
        contractUntilValue,
        setAgeRange,
        ageRange,
        setMinAppearances,
        setStartsOnly,
        setFoot,
        setRegionValues,
        setCompetitionValues,
        handleSelectedTags,
        setIsPlayerFilterChange,
        setIsAltered,
        setSimilarPlayerResultsList,
        setPlayerInitialAttributes,
        setIsExactMatchesOnly,
        hideNotification,
        setNotificationContent,
        setDisplayNotification
    ]);

    useEffect(() => {
        if (originPage === 'Similarplayers Tab' || originPage === 'Search For Similar') {
            handleClearPlayerList();
        }
    }, [])

    return (
        <MainContainer isBlurred={isBlurred!} className={'main-container player-detail-page'}>
            <PageHeader title='Players' clearPlayerList={playerSearchResultsVisible} onClearPlayerListClick={() => {
                handleClearPlayerList();
                navigate("/playersearch")
            }} playerResultList />
            {playerSearchResultsVisible && (
                <div className="player-tab-content player-filter-result">
                    <PlayerFilterResultsPage onClearPlayerListClick={() => {
                        handleClearPlayerList();
                        navigate("/playersearch")
                    }} isFromSuccession={false}/>
                </div>
            )}
        </MainContainer>
    )
}

export default PlayerSearchComponent;
